import { createFileRoute } from "@tanstack/react-router";
import type React from "react";
import { useTranslation } from "react-i18next";

import { GlobalFilterInput } from "@/components/shared/data-table/filters/inputs/global-filter";
import { NewAccountForm } from "@/components/shared/form/new-account";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { AccountsDataProvider } from "@/features/settings/accounts-table/accounts-data-provider";
import { AccountsTable } from "@/features/settings/accounts-table/accounts-table";
import { AutomaticAccountsFilter } from "@/features/settings/accounts-table/automatic-accounts-filter";
import {
  AccountsTableInstanceProvider,
  useAccountsTableInstanceContext,
} from "@/features/settings/accounts-table/table-instance-provider";
import { Plus } from "lucide-react";
import { useState } from "react";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/_settings/einstellungen/konten",
)({
  component: Setup,
});

const AccountsSearchBar = () => {
  const { t } = useTranslation();
  const { table, onGlobalFilterChange } = useAccountsTableInstanceContext();

  const currentFilter = table.getState().globalFilter || "";

  return (
    <GlobalFilterInput
      placeholder={t("accounts.search_placeholder")}
      value={currentFilter}
      onChange={onGlobalFilterChange}
      className="max-w-md"
    />
  );
};

const CreateAccountButton = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="gap-2">
          <Plus className="h-4 w-4" />
          {t("accounts.new")}
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <NewAccountForm onSuccess={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  );
};

function Setup() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col min-h-full">
      <div className="flex-1 flex flex-col">
        <div className="font-bold text-xl mb-2.5">{t("expense_accounts")}</div>
        <AccountsDataProvider>
          <AccountsTableInstanceProvider>
            <div className="flex flex-row items-center gap-4 mb-2.5">
              <AccountsSearchBar />
              <AutomaticAccountsFilter />
              <div className="flex-1" />
              <CreateAccountButton />
            </div>
            <AccountsTable />
          </AccountsTableInstanceProvider>
        </AccountsDataProvider>
      </div>
    </div>
  );
}
